export enum NotificationsTypeEnum {
	versionUpdate = 1,
	newRecommendation = 2,
	dataUpdated = 3,
	cacheStarted = 4,
}
